import { Communities } from "../../../routes/communities/Communities";
import { Events } from "../../../routes/events/Events";
import { Login } from "../../../routes/login/Login";
import { Users } from "../../../routes/users/Users";
import { Activity } from "../../../routes/activity/Activity";
import { SystemLogs } from "../../../routes/systemLogs/SystemLogs";
import { Settings } from "../../../routes/settings/Settings";
import {CurrentEventEditForm} from "../../../routes/events/CurrentEventEditForm";
import {FTJDashboard} from "../../../routes/ftj/Dashboard";
import {Curricula} from "../../../routes/curricula/Curricula";
import {ContentList} from "../../../routes/content/ContentList";
import {Content} from "../../../routes/content/Content";
import {SHIHRDashboard} from "../../../routes/shihr/Dashboard";
import NotificationDashboard from "../../../routes/notificationDashboard/NotificationDashboard";
import Sessions from "../../../routes/sessions/Sessions";
import CurriculaDetail from "../../../routes/CurriculaDetail/CurriculaDetail";
import { Volume } from "../../../routes/ftj/Volumes/Volume";
import { Template } from "../../../routes/ftj/Templates/Template";
import { Folder } from "../../../routes/ftj/Folders/Folder";
import Help from "../../../routes/help/Help";

export interface routeInterface {
  path: string;
  component: any;
}

const authProtectedRoutes: routeInterface[] = [
  { path: "/", component: ContentList },
  { path: "/old", component: Content },
  { path: "/users", component: Users },
  { path: "/communities", component: Communities },
  { path: "/seminars", component: Events },
  { path: "/CurrentEventEditForm/:id", component: CurrentEventEditForm },
  { path: "/settings", component: Settings },
  { path: "/curricula", component: FTJDashboard },
  { path: "/shihr", component: SHIHRDashboard },
  { path: "/curriculaList", component: Curricula },
  { path: "/curriculaDetail/:id", component: CurriculaDetail },
  { path: "/activity", component: Activity },
  { path: "/system-logs", component: SystemLogs },
  { path: "/notification", component: NotificationDashboard },
  { path: "/sessions", component: Sessions },
  { path: "/volume", component: Volume },
  { path: "/template", component: Template },
  { path: "/template/:id", component: Template },
  { path: "/folder", component: Folder },
  { path: "/help", component: Help },
  { path: "/help/new", component: Help },
  { path: "/help/:id", component: Help },
];

const publicRoutes: routeInterface[] = [{ path: "/login", component: Login }];

export { authProtectedRoutes, publicRoutes };
